/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_RedirectingInputs */

const en_billing_redirecting = /** @type {(inputs: Billing_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking you to the payment page…`)
};

const id_billing_redirecting = /** @type {(inputs: Billing_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengarahkan ke halaman pembayaran…`)
};

/**
* | output |
* | --- |
* | "Taking you to the payment page…" |
*
* @param {Billing_RedirectingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_redirecting = /** @type {((inputs?: Billing_RedirectingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_RedirectingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_redirecting(inputs)
	return en_billing_redirecting(inputs)
});